import * as angular from 'angular';
import ProcessMapsBridge from './bridges/ProcessMapsBridge';

angular
  .module('flowingly.runner.processmapsv2')
  .component('processMapsV2', ProcessMapsBridge);
